module.exports = __webpack_public_path__ + "images/pages/for_business/pc/sec09_6cb416152160aaa8474fd5d5aa8f7cbd.jpg";